export default "__VITE_ASSET__1BEzMHRk__"